"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _EventType2 = _interopRequireDefault(require("../pointer/EventType.js"));

var _css = require("../css.js");

var _math = require("../math.js");

var _easing = require("../easing.js");

var _events = require("../events.js");

var _Event = require("../events/Event.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/control/ZoomSlider
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * The enum for available directions.
 *
 * @enum {number}
 */
var Direction = {
  VERTICAL: 0,
  HORIZONTAL: 1
};
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-zoomslider'] CSS class name.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 */

/**
 * @classdesc
 * A slider type of control for zooming.
 *
 * Example:
 *
 *     map.addControl(new ZoomSlider());
 *
 * @api
 */

var ZoomSlider =
/** @class */
function (_super) {
  __extends(ZoomSlider, _super);
  /**
   * @param {Options} [opt_options] Zoom slider options.
   */


  function ZoomSlider(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      render: options.render
    }) || this;
    /**
     * @type {!Array<import("../events.js").EventsKey>}
     * @private
     */

    _this.dragListenerKeys_ = [];
    /**
     * Will hold the current resolution of the view.
     *
     * @type {number|undefined}
     * @private
     */

    _this.currentResolution_ = undefined;
    /**
     * The direction of the slider. Will be determined from actual display of the
     * container and defaults to Direction.VERTICAL.
     *
     * @type {Direction}
     * @private
     */

    _this.direction_ = Direction.VERTICAL;
    /**
     * @type {boolean}
     * @private
     */

    _this.dragging_;
    /**
     * @type {number}
     * @private
     */

    _this.heightLimit_ = 0;
    /**
     * @type {number}
     * @private
     */

    _this.widthLimit_ = 0;
    /**
     * @type {number|undefined}
     * @private
     */

    _this.startX_;
    /**
     * @type {number|undefined}
     * @private
     */

    _this.startY_;
    /**
     * The calculated thumb size (border box plus margins).  Set when initSlider_
     * is called.
     * @type {import("../size.js").Size}
     * @private
     */

    _this.thumbSize_ = null;
    /**
     * Whether the slider is initialized.
     * @type {boolean}
     * @private
     */

    _this.sliderInitialized_ = false;
    /**
     * @type {number}
     * @private
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 200;
    var className = options.className !== undefined ? options.className : 'ol-zoomslider';
    var thumbElement = document.createElement('button');
    thumbElement.setAttribute('type', 'button');
    thumbElement.className = className + '-thumb ' + _css.CLASS_UNSELECTABLE;
    var containerElement = _this.element;
    containerElement.className = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL;
    containerElement.appendChild(thumbElement);
    containerElement.addEventListener(_EventType2["default"].POINTERDOWN, _this.handleDraggerStart_.bind(_this), false);
    containerElement.addEventListener(_EventType2["default"].POINTERMOVE, _this.handleDraggerDrag_.bind(_this), false);
    containerElement.addEventListener(_EventType2["default"].POINTERUP, _this.handleDraggerEnd_.bind(_this), false);
    containerElement.addEventListener(_EventType["default"].CLICK, _this.handleContainerClick_.bind(_this), false);
    thumbElement.addEventListener(_EventType["default"].CLICK, _Event.stopPropagation, false);
    return _this;
  }
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  ZoomSlider.prototype.setMap = function (map) {
    _super.prototype.setMap.call(this, map);

    if (map) {
      map.render();
    }
  };
  /**
   * Initializes the slider element. This will determine and set this controls
   * direction_ and also constrain the dragging of the thumb to always be within
   * the bounds of the container.
   *
   * @return {boolean} Initialization successful
   * @private
   */


  ZoomSlider.prototype.initSlider_ = function () {
    var container = this.element;
    var containerWidth = container.offsetWidth;
    var containerHeight = container.offsetHeight;

    if (containerWidth === 0 && containerHeight === 0) {
      return this.sliderInitialized_ = false;
    }

    var containerStyle = getComputedStyle(container);
    containerWidth -= parseFloat(containerStyle['paddingRight']) + parseFloat(containerStyle['paddingLeft']);
    containerHeight -= parseFloat(containerStyle['paddingTop']) + parseFloat(containerStyle['paddingBottom']);
    var thumb =
    /** @type {HTMLElement} */
    container.firstElementChild;
    var thumbStyle = getComputedStyle(thumb);
    var thumbWidth = thumb.offsetWidth + parseFloat(thumbStyle['marginRight']) + parseFloat(thumbStyle['marginLeft']);
    var thumbHeight = thumb.offsetHeight + parseFloat(thumbStyle['marginTop']) + parseFloat(thumbStyle['marginBottom']);
    this.thumbSize_ = [thumbWidth, thumbHeight];

    if (containerWidth > containerHeight) {
      this.direction_ = Direction.HORIZONTAL;
      this.widthLimit_ = containerWidth - thumbWidth;
    } else {
      this.direction_ = Direction.VERTICAL;
      this.heightLimit_ = containerHeight - thumbHeight;
    }

    return this.sliderInitialized_ = true;
  };
  /**
   * @param {PointerEvent} event The browser event to handle.
   * @private
   */


  ZoomSlider.prototype.handleContainerClick_ = function (event) {
    var view = this.getMap().getView();
    var relativePosition = this.getRelativePosition_(event.offsetX - this.thumbSize_[0] / 2, event.offsetY - this.thumbSize_[1] / 2);
    var resolution = this.getResolutionForPosition_(relativePosition);
    var zoom = view.getConstrainedZoom(view.getZoomForResolution(resolution));
    view.animateInternal({
      zoom: zoom,
      duration: this.duration_,
      easing: _easing.easeOut
    });
  };
  /**
   * Handle dragger start events.
   * @param {PointerEvent} event The drag event.
   * @private
   */


  ZoomSlider.prototype.handleDraggerStart_ = function (event) {
    if (!this.dragging_ && event.target === this.element.firstElementChild) {
      var element =
      /** @type {HTMLElement} */
      this.element.firstElementChild;
      this.getMap().getView().beginInteraction();
      this.startX_ = event.clientX - parseFloat(element.style.left);
      this.startY_ = event.clientY - parseFloat(element.style.top);
      this.dragging_ = true;

      if (this.dragListenerKeys_.length === 0) {
        var drag = this.handleDraggerDrag_;
        var end = this.handleDraggerEnd_;
        var doc = this.getMap().getOwnerDocument();
        this.dragListenerKeys_.push((0, _events.listen)(doc, _EventType2["default"].POINTERMOVE, drag, this), (0, _events.listen)(doc, _EventType2["default"].POINTERUP, end, this));
      }
    }
  };
  /**
   * Handle dragger drag events.
   *
   * @param {PointerEvent} event The drag event.
   * @private
   */


  ZoomSlider.prototype.handleDraggerDrag_ = function (event) {
    if (this.dragging_) {
      var deltaX = event.clientX - this.startX_;
      var deltaY = event.clientY - this.startY_;
      var relativePosition = this.getRelativePosition_(deltaX, deltaY);
      this.currentResolution_ = this.getResolutionForPosition_(relativePosition);
      this.getMap().getView().setResolution(this.currentResolution_);
    }
  };
  /**
   * Handle dragger end events.
   * @param {PointerEvent} event The drag event.
   * @private
   */


  ZoomSlider.prototype.handleDraggerEnd_ = function (event) {
    if (this.dragging_) {
      var view = this.getMap().getView();
      view.endInteraction();
      this.dragging_ = false;
      this.startX_ = undefined;
      this.startY_ = undefined;
      this.dragListenerKeys_.forEach(_events.unlistenByKey);
      this.dragListenerKeys_.length = 0;
    }
  };
  /**
   * Positions the thumb inside its container according to the given resolution.
   *
   * @param {number} res The res.
   * @private
   */


  ZoomSlider.prototype.setThumbPosition_ = function (res) {
    var position = this.getPositionForResolution_(res);
    var thumb =
    /** @type {HTMLElement} */
    this.element.firstElementChild;

    if (this.direction_ == Direction.HORIZONTAL) {
      thumb.style.left = this.widthLimit_ * position + 'px';
    } else {
      thumb.style.top = this.heightLimit_ * position + 'px';
    }
  };
  /**
   * Calculates the relative position of the thumb given x and y offsets.  The
   * relative position scales from 0 to 1.  The x and y offsets are assumed to be
   * in pixel units within the dragger limits.
   *
   * @param {number} x Pixel position relative to the left of the slider.
   * @param {number} y Pixel position relative to the top of the slider.
   * @return {number} The relative position of the thumb.
   * @private
   */


  ZoomSlider.prototype.getRelativePosition_ = function (x, y) {
    var amount;

    if (this.direction_ === Direction.HORIZONTAL) {
      amount = x / this.widthLimit_;
    } else {
      amount = y / this.heightLimit_;
    }

    return (0, _math.clamp)(amount, 0, 1);
  };
  /**
   * Calculates the corresponding resolution of the thumb given its relative
   * position (where 0 is the minimum and 1 is the maximum).
   *
   * @param {number} position The relative position of the thumb.
   * @return {number} The corresponding resolution.
   * @private
   */


  ZoomSlider.prototype.getResolutionForPosition_ = function (position) {
    var fn = this.getMap().getView().getResolutionForValueFunction();
    return fn(1 - position);
  };
  /**
   * Determines the relative position of the slider for the given resolution.  A
   * relative position of 0 corresponds to the minimum view resolution.  A
   * relative position of 1 corresponds to the maximum view resolution.
   *
   * @param {number} res The resolution.
   * @return {number} The relative position value (between 0 and 1).
   * @private
   */


  ZoomSlider.prototype.getPositionForResolution_ = function (res) {
    var fn = this.getMap().getView().getValueForResolutionFunction();
    return (0, _math.clamp)(1 - fn(res), 0, 1);
  };
  /**
   * Update the zoomslider element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  ZoomSlider.prototype.render = function (mapEvent) {
    if (!mapEvent.frameState) {
      return;
    }

    if (!this.sliderInitialized_ && !this.initSlider_()) {
      return;
    }

    var res = mapEvent.frameState.viewState.resolution;
    this.currentResolution_ = res;
    this.setThumbPosition_(res);
  };

  return ZoomSlider;
}(_Control["default"]);

var _default = ZoomSlider;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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